import http from "@utils/request";

/** 获取报表 */
export const getReportData = (start_time, end_time,sitenolist='sitelist',page='report_cost') => http({//获取费用报表
    method: "POST",
    url: "/bigdata/GetReportData",
    data: {
        start_time, end_time,sitenolist,page
    },
});